import { Storage } from '@ionic/storage'
export const storage = new Storage();
storage.create();